
import Consultancy from '../components/website/Consultancy/Consultancy'
import CallAction from '../components/website/CallAction/CallAction'
import Layout from '../layouts/Layout'
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';


const url = typeof window !== 'undefined' ? window.location.href : '';
const ConsultancyPage = () => (
  
    <Layout>
       <Helmet>
       <title>Free Audit | BizDamn(Leading Wordpress and Web Development Company in Delhi)</title>
        <meta name="description" content='Free Audit of Your Website by Professional Web Developer and Designers' />
        <meta name="keywords" content="Free Consultancy of Your Website, Free Audit of Your Website,Best Wordpress and Web Development Company in Delhi"/>
        <meta property="og:type" content="website" />
        <meta property="og:title" content='Free Consultancy to take your Business Online | BizDamn' />
        <meta property="og:description" content='Free Consultancy on Web Development and taking your Business Online by leading Wordpress and Web Development Company in Delhi' />
        <meta property="og:url" content='https://bizdamn.tech/consultancy' />
        <meta property="og:image:width"  />
        <meta property="og:image:height" />
        <script type="application/ld+json">
        {`
         {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://bizdamn.tech"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Free Consultancy",
              "item": "https://bizdamn.tech/consultancy"
            }]
          },
          {
            "@context": "https://schema.org/",
            "@type": "WebPage",
            "name": "Free Wordpress and Web Development Consultancy",
            "speakable":
            {
             "@type": "SpeakableSpecification",
             "xPath": [
               "/html/head/title",
               "/html/head/meta[@name='description']/@content"
               ]
             },
            "url": ${url}
            },
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [{
                "@type": "Question",
                "name": " Why my Business needs a Website?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": " <ul>
                  <li>It will work 24x7 for you</li>
                  <li>Without a website, people may question your legitimacy as a business</li>
                  <li>Retarget your Customers Easily</li>
                  <li>You can reach Global Audience Easily</li>
                </ul>"
                }
              }, {
                "@type": "Question",
                "name": " Do we provide Free Website consultation?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "  Yes, BizDamn team provides Free Website Consultation. <br/>
                  And I would love to help you😊"
                }
              }]
            }
          `}
            </script>
      </Helmet>
            {/* Breadcrumbs */}
            <section className="breadcrumbs">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <ol>
            <li><Link to='/'>Home</Link></li>
            <li>Audit</li>
          </ol>
        </div>
      </div>
    </section>
      <Consultancy/>
      <CallAction/>
      
    <section className='container my-4'>
    <p className="" style={{
            color: "#2D94F3", fontSize: "2rem",
            textAlign: "center"
        }}>How a Website will help you grow Business</p>
      <div className="accordion accordion-flush" id="accordionFlushExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingOne">
      <button
        className="accordion-button collapsed"
        type="button"
        data-mdb-toggle="collapse"
        data-mdb-target="#flush-collapseOne"
        aria-expanded="false"
        aria-controls="flush-collapseOne"
      >
       Why my Business needs a Website?
      </button>
    </h2>
    <div
      id="flush-collapseOne"
      className="accordion-collapse collapse"
      aria-labelledby="flush-headingOne"
      data-mdb-parent="#accordionFlushExample"
    >
      <div className="accordion-body">
        <ul>
          <li>It will work 24x7 for you</li>
          <li>Without a website, people may question your legitimacy as a business</li>
          <li>Retarget your Customers Easily</li>
          <li>You can reach Global Audience Easily</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingTwo">
      <button
        className="accordion-button collapsed"
        type="button"
        data-mdb-toggle="collapse"
        data-mdb-target="#flush-collapseTwo"
        aria-expanded="false"
        aria-controls="flush-collapseTwo"
      >
        Do we provide Free Website consultation?
      </button>
    </h2>
    <div
      id="flush-collapseTwo"
      className="accordion-collapse collapse"
      aria-labelledby="flush-headingTwo"
      data-mdb-parent="#accordionFlushExample"
    >
      <div className="accordion-body">
      Yes, BizDamn team provides Free Website Consultation. <br/>
      And I would love to help you😊
      </div>
    </div>
  </div>
</div>
      </section>

    </Layout>
  )

export default ConsultancyPage